// Utility to convert video URLs into embeddable formats

export const getYouTubeId = (url) => {
  const regExp = /^.*(youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=|&v=)([^#&?]*).*/;
  const match = url.match(regExp);
  return match && match[2].length === 11 ? match[2] : null;
};

export const getVideoEmbed = (video) => {
  const { video_type, video_url } = video;

  if (video_type === 'youtube') {
    const id = getYouTubeId(video_url);
    return {
      type: 'iframe',
      src: id ? `https://www.youtube.com/embed/${id}` : video_url,
    };
  }

  if (video_type === 'mp4') {
    return { type: 'video', src: video_url };
  }

  if (video_type === 'instagram') {
    // Instagram reel embed
    let embedUrl = video_url;
    if (!video_url.includes('/embed')) {
      embedUrl = video_url.replace(/\/?$/, '/embed');
    }
    return { type: 'iframe', src: embedUrl };
  }

  if (video_type === 'tiktok') {
    // TikTok: extract video id for embed
    const match = video_url.match(/video\/(\d+)/);
    const id = match ? match[1] : null;
    return {
      type: 'iframe',
      src: id ? `https://www.tiktok.com/embed/v2/${id}` : video_url,
    };
  }

  return { type: 'iframe', src: video_url };
};
